import UpAppLogo from '@/assets/logos/upseat_logo.svg'
import { Button } from '@/components/ui/button'

enum EmailOptions {
  REPORT_BUG = 'Report a bug',
  GET_IN_TOUCH = 'Get in touch',
}

interface DeviceNotSupportedProps {
  sendEmail: (emailSubject: EmailOptions) => void
}

export const DeviceNotSupported = ({ sendEmail }: DeviceNotSupportedProps) => {
  return (
    <div className="upseat w-screen h-[100dvh] bg-purple overflow-hidden flex">
      <div className="flex flex-col justify-center items-center w-full h-full px-12">
        <img src={UpAppLogo} alt="up-logo" className={`w-6 my-2`} />
        <h5 className="text-white text-xl">{`Device not supported`}</h5>
        <h3 className="text-white text-sm text-center font-body">
          {`To ensure the best experience, this page requires a larger screen.`}
        </h3>

        {/* message to contact customer support */}
        <div className="flex flex-col gap-2 my-4">
          <h3 className="text-white text-sm text-center font-body mt-2">
            {`If you believe this is an error, please contact our customer support:`}
          </h3>
          <Button
            variant="primaryYellow"
            onClick={() => sendEmail(EmailOptions.REPORT_BUG)}
            className="py-2 px-4 text-sm"
          >
            {`Report a bug`}
          </Button>
        </div>

        <div className="flex flex-col gap-2 my-4">
          <h3 className="text-white text-sm text-center font-body mt-2">
            {`You can always find your tickets in the purchase confirmation email from the venue.`}
          </h3>
        </div>
      </div>
    </div>
  )
}
